import { defineSlotRecipe as e } from "@pandacss/dev";
import { createAnatomy as t } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/anatomy/dist/index.mjs";
const i = t("sidebar-menu", [
  "root",
  "submenu",
  "submenuTitle",
  "item",
  "itemLabel",
  "itemIcon"
]), r = e({
  className: "sidebar-menu",
  slots: i.keys(),
  variants: {
    disabled: {
      true: {
        itemLabel: {
          color: "text-disabled"
        },
        itemIcon: {
          color: "fg-disabled"
        }
      },
      false: {}
    }
  },
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "8",
      backgroundColor: "alpha-white-20",
      paddingLeft: "6",
      paddingRight: "5",
      paddingY: "4",
      width: "fit-content",
      backdropFilter: "blur(32px)",
      borderRight: "1px solid",
      borderColor: "alpha-black-20"
    },
    submenu: {
      display: "flex",
      flexDirection: "column",
      gap: "1"
    },
    submenuTitle: {
      fontSize: "xs",
      fontWeight: "semiBold",
      color: "text-tertiary",
      lineHeight: "xs",
      letterSpacing: "xs",
      marginBottom: "2",
      marginLeft: "4",
      textTransform: "uppercase"
    },
    item: {
      display: "flex",
      gap: "3",
      minWidth: "233px",
      alignItems: "center",
      borderRadius: "3",
      paddingY: "3",
      cursor: "pointer",
      paddingX: "4",
      _hover: {
        backgroundColor: "alpha-black-10"
      }
    },
    itemLabel: {
      fontSize: "lg",
      fontWeight: "normal",
      color: "text-primary",
      flexGrow: "1"
    },
    itemIcon: {
      width: "4",
      height: "4",
      color: "fg-black"
    }
  }
});
export {
  r as sidebarMenu
};
